import { IPagination } from '@shared/interfaces/pagination.interface';

export class Pagination<T> implements IPagination {
  public page: number = Number(1);
  public isLoading: boolean = Boolean(true);
  public entries: T[] = [];

  constructor(partial: any) {
    Object.assign(this, {
      ...partial
    });
  }
}
